
<template>

  <div class="ui center aligned inverted primary segment">
    <div class="ui centered grid">

      <!-- Participations counter and change buttons -->
      <div class="three column row">

        <div class="column" style="padding: 0 0 0 3px;">
          <button class="ui fluid yellow icon button" @click="increment()">
            <i class="plus icon" />
          </button>
        </div>

        <div class="center aligned column">
          <h2 class="ui almarai yellow header">
            {{ participations }}
            <div class="sub header">مشاركات</div>
          </h2>
        </div>

        <div class="column" style="padding: 0 0 0 3px;">
          <button class="ui fluid yellow icon button" @click="decrement()">
            <i class="minus icon" />
          </button>
        </div>

      </div>

      <!-- Participate button -->
      <div class="row">
        <button class="ui fluid yellow button" @click="participate()">
          <span class="ui almarai large text">شارك</span>
        </button>
      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {

  name: 'Participation',
  props: {

    work: Object

  },
  data: () => ({

    participations: 1,
    stepSize: 1

  }),
  watch: {

    work(newWork) {

      if (newWork.target && newWork.completed + this.participations > newWork.target) {

        this.participations = newWork.target - newWork.completed;

      }

    }

  },
  methods: {

    increment() {

      if (this.work.target) {

        if (this.work.completed + this.participations + this.stepSize <= this.work.target)
          this.participations += this.stepSize;

      } else {

        if (this.participations < this.stepSize * 10)
          this.participations += this.stepSize;

      }

    },

    decrement() {

      if (this.participations > this.stepSize)
        this.participations -= this.stepSize;

    },

    async participate() {

      if (confirm(`أشارك بهذا العمل ${this.participations} مشاركات وأهدي ثوابه إلى ${this.work.ehdaa} وجميع المشاركين بالعمل وموتاهم`)) {

        try {

          await axios.put(`${process.env.VUE_APP_BASE_URL}/works`, {

            workID: this.work.id,
            increment: this.participations

          });

          this.$gtag.event('Participate', {

            event_category: 'Works',
            event_label: `${this.work.title} - ${this.work.ehdaa}`,
            value: this.participations

          });

        } catch (err) {

          alert(err);

        }

      }

    }

  }

}
</script>

<style scoped>
button {
  touch-action: manipulation;
}
</style>
